export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_02.ef9fb150.jpg";